import React, { useState, Fragment } from 'react';
import cn from 'classnames';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { func } from 'prop-types';
import Layout from '../../components/Layout/Layout';
import Card from '../../components/Card/Card';
import PaymentsData from '../../components/Finances/PaymentsData';
import PaymentOrders from '../../components/Finances/PaymentOrders/PaymentOrders';
import PaymentHoldDetails from '../../components/Finances/PaymentHoldDetails';
import WithAlert from '../../hoc/WithAlert';
import Hold2BalanceOrder from '../../components/Finances/Hold2BalanceOrder';
import { updateLocation } from '../../utils/utils';
import { useCardNavTabsWithRoutes } from '../../components/Card/cardHelpers';

const propTypes = {
  showAlert: func,
  intl: intlShape.isRequired,
};

const defaultProps = {
  showAlert() {},
};

const tabKeys = {
  data: 1,
  hold: 2,
  payment: 3,
};

const navs = (intl, isSlave) => {
  const navBtns = [
    <a
      className="list-contract-btn"
      title={intl.formatMessage({
        id: 'payments.list.title',
        defaultMessage: 'Financial info',
      })}
    >
      <FormattedMessage id="payments.list.title" defaultMessage="Financial info" />
    </a>,
    <a
      className="list-contract-btn"
      title={intl.formatMessage({
        id: 'payments.hold.title',
        defaultMessage: 'Hold detail',
      })}
    >
      <FormattedMessage id="payments.hold.title" defaultMessage="Hold detail" />
    </a>,
  ];
  if (!isSlave) {
    navBtns.push(
      <a
        className="list-contract-btn"
        title={intl.formatMessage({
          id: 'payments.orders.title',
          defaultMessage: 'Payment orders',
        })}
      >
        <FormattedMessage id="payments.orders.title" defaultMessage="Payments order" />
      </a>,
    );
  }
  return navBtns;
};

const btns = [Hold2BalanceOrder];

const FinancesPage = ({ showAlert, intl, history, isMember, className, isSlave }) => {
  const { activeTab } = useCardNavTabsWithRoutes({ tabKeys, history });
  const [loading, setLoadingState] = useState(false);
  const [tabActive, setTabActive] = useState(1);
  const [showAlertPayment, setShowAlertPayment] = useState(false);
  const [messageAlert, setMessageAlert] = useState(null);

  const getBtnProps = () => ({
    hold2BalanceOrderDisable: isSlave && !isMember,
  });

  const handleTabChange = (tab) => {
    Object.keys(tabKeys).forEach((key) => {
      if (tabKeys[key] === tab) {
        if (key !== 'data') {
          updateLocation({ tab: key });
        } else {
          updateLocation({}, true);
        }
        setTabActive(key);
      }
    });
  };

  const alertText = messageAlert || intl.formatMessage({ id: 'payments.choose_purse.tp_sd_ws' });

  const renderTabs = () => {
    const tabs = [
      <PaymentsData key="PaymentsData" />,
      <PaymentHoldDetails
        key="PaymentHoldDetails"
        setLoadingState={setLoadingState}
        loading={loading}
        intl={intl}
      />,
    ];
    if (!isSlave) {
      tabs.push(
        <PaymentOrders
          // messageAlert={alertText}
          key="PaymentOrders"
          setMessageAlert={setMessageAlert}
          showAlertPayment={showAlertPayment}
          setShowAlertPayment={setShowAlertPayment}
        />,
      );
    }
    return tabs;
  };

  return (
    <Fragment>
      {!isMember ? (
        <Layout formattedTitle="pages.payments.title" className="finances-page">
          <Layout.Col>
            <Card.NavTabs
              className="finances-card"
              navItems={navs(intl, isSlave)}
              tabProps={{ history }}
              btnItems={btns}
              btnProps={getBtnProps()}
              showAlert={showAlert}
              loading={loading}
              activeTab={activeTab}
              onTabChange={handleTabChange}
            >
              {renderTabs()}
            </Card.NavTabs>
          </Layout.Col>
        </Layout>
      ) : (
        <Card.NavTabs
          navItems={navs(intl)}
          tabProps={{ history }}
          btnItems={btns}
          btnProps={getBtnProps()}
          showAlert={showAlert}
          loading={loading}
          activeTab={activeTab}
          className={className}
        >
          <PaymentsData isMember={isMember} />
          <PaymentHoldDetails
            setLoadingState={setLoadingState}
            loading={loading}
            isMember={isMember}
          />
          {!isSlave && (
            <PaymentOrders
              showAlert={showAlert}
              isMember={isMember}
              showAlertPayment={showAlertPayment}
              setShowAlertPayment={setShowAlertPayment}
              setMessageAlert={setMessageAlert}
            />
          )}
        </Card.NavTabs>
      )}
    </Fragment>
  );
};

FinancesPage.propTypes = propTypes;
FinancesPage.defaultProps = defaultProps;

const mapStateToProps = ({ webmaster }) => ({
  profile: webmaster.profile,
  isSlave: webmaster.isSlave,
});

export default connect(mapStateToProps)(WithAlert(injectIntl(FinancesPage)));
